export default "__VITE_ASSET__21597631__"